import { createContext, useContext } from "react";
import type { SelectContext as SelectContextType } from "./types";

const SelectContext = createContext<SelectContextType | undefined>(undefined);

export const SelectProvider = SelectContext.Provider;

export const useSelectContext = () => {
  const context = useContext(SelectContext);
  if (!context) {
    throw new Error("useSelectContext must be used within a SelectProvider");
  }
  return context;
};
